export default class Overview {
  constructor(element) {
    if (!element) {
      return;
    }
    this.element = element;
    this.showAmount = 9;
    this.hideItems();
    this.showOrHideButton();
    for (const node of this.element.querySelectorAll('.overview__showMore')) {
      node.addEventListener('click', () => {
        this.showAll();
        this.showOrHideButton();
      });
    }
  }

  hideItems() {
    let i = 0;
    for (const node of this.element.querySelectorAll('.overview__item')) {
      i++;
      if (i > this.showAmount) {
        node.classList.add('hidden');
      }
    }
  }

  showAll() {
    for (const node of this.element.querySelectorAll('.overview__item')) {
      node.classList.remove('hidden');
    }
  }

  hasHiddenItems() {
    return this.element.querySelectorAll('.overview__item.hidden').length;
  }

  showOrHideButton() {
    if (this.hasHiddenItems()) {
      for (const node of this.element.querySelectorAll('.overview__showMore')) {
        node.classList.remove('hidden');
      }
    } else {
      for (const node of this.element.querySelectorAll('.overview__showMore')) {
        node.classList.add('hidden');
      }
    }
  }
};
